import Grid from "@material-ui/core/Grid";
import React from "react";
import { ProgressBar } from "../../../../../../../../components/progress-bar/progress-bar.component";
import { FlyerDetailPageTabPageDetailsProgressProps } from "./flyer-detail-page-tab-page-details-progress.props";

export const FlyerDetailPageTabPageDetailsProgress = (
  props: FlyerDetailPageTabPageDetailsProgressProps
) => (
  <Grid item={true} xs={3} sm={3} md={3} lg={3}>
    <ProgressBar showIf={props.numberOfPositions > 0} percent={props.positionWithoutProducts} />
  </Grid>
);
